import * as React from "react";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
const makeOptions = (options) => options.map((option) => {
  if (typeof option === "string") {
    return { label: option, value: option };
  }
  const [label, value] = option;
  return { label, value };
});
const createEvent = (name, value) => ({
  target: { name, value }
});
const SelectField = ({ name, field, title, error, value, onChange, inputHelp }) => {
  if (field.type !== "select") {
    throw new Error("Invalid field type passed!");
  }
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `${name}-select`,
      label: title,
      error,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: inputHelp
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        options: makeOptions(field.options),
        "aria-label": `Select ${field.title}`,
        clearable: !field.required,
        name,
        value,
        size: "small",
        onChange: (newValue) => onChange(createEvent(name, newValue))
      }
    )
  );
};
export default SelectField;
